import { render, staticRenderFns } from "./CashPayments.vue?vue&type=template&id=095a365c"
import script from "./CashPayments.vue?vue&type=script&lang=js"
export * from "./CashPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports